import { api } from "./client"

export type Candidate = {
  id: string
  organization_id: string
  full_name: string
  email: string
  phone: string | null
  linkedin_url: string | null
  location: string | null
  source: string | null
  tags: string[]
  notes: string | null
  created_at: string
  updated_at: string
}

export type SeniorityLevel =
  | "intern"
  | "junior"
  | "mid"
  | "senior"
  | "lead"
  | "staff"
  | "principal"

export type CvParsed = {
  full_name: string | null
  location: string | null
  phone: string | null
  email: string | null
  experience_years: number | null
  skills: string[]
  languages: string[]
  education: { degree: string; institution: string; year: string | null }[]
  work_history: {
    company: string
    role: string
    start_date: string | null
    end_date: string | null
    summary: string | null
  }[]
}

export type CandidateApplication = {
  id: string
  job_id: string
  job: { id: string; title: string; slug: string }
  current_stage_id: string | null
  stage: { id: string; name: string; color: string } | null
  resume: {
    id: string
    file_name: string
    mime_type: string | null
    size_bytes: number | null
  } | null
  analysis: {
    match_score: number | null
    summary: string | null
    strengths: string[] | null
    weaknesses: string[] | null
    risk_factors: string[] | null
    seniority_level: SeniorityLevel | null
    interview_questions: { technical: string[]; behavioral: string[] } | null
    skills_extracted: string[] | null
    experience_years: number | null
    model_used: string | null
    error: string | null
    created_at: string
  } | null
  cv_parsed: CvParsed | null
  status: string
  applied_at: string
}

export type CandidateDetail = Candidate & { applications: CandidateApplication[] }

export const candidatesApi = {
  list: (q?: string) =>
    api<{ data: Candidate[] }>(`/candidates${q ? `?q=${encodeURIComponent(q)}` : ""}`),
  get: (id: string) => api<{ data: CandidateDetail }>(`/candidates/${id}`),
  updateNotes: (id: string, notes: string) =>
    api<{ ok: boolean }>(`/candidates/${id}/notes`, {
      method: "PUT",
      body: { notes },
    }),
  addTag: (id: string, tag: string) =>
    api<{ ok: boolean }>(`/candidates/${id}/tags`, {
      method: "POST",
      body: { tag },
    }),
  removeTag: (id: string, tag: string) =>
    api<{ ok: boolean }>(`/candidates/${id}/tags/${encodeURIComponent(tag)}`, {
      method: "DELETE",
    }),
}
